// Shared by GCP project, cluster, and application funding forms.
export const WBS_CODE_PATTERN = /^[A-Z0-9]+(?:-[A-Z0-9]+){2,}$/
export const COST_CENTER_PATTERN = /^[A-Z0-9]{1,7}-[A-Z0-9]{1,7}$/
